<template src="./PendingToFinish.html"></template>
<script>
import { getPendingToFinish } from "../../../services";
import { getTodayFormat, formatDate, formatDateUTC } from "../../../utils/computeds";

const filterItems = (query, data) => {
  if (!query) {
    return data;
  }
  return data.filter((el) => {
    const companyName = el.companyName ? el.companyName.toLowerCase() : "";
    return companyName.includes(query.toLowerCase());
  });
};

export default {
  name: "PendingToFinish",
  data() {
    return {
      items: [],
      counts: { overdue: 0, today: 0, tomorrow: 0 },
      format: "DD [de] MMMM, YYYY",
      sortOrder: "asc",
      sortField: "evaluatedName",
      search: "",
    };
  },
  created() {
    this.loadPendingToFinish();
  },
  methods: {
    async loadPendingToFinish() {
      try {
        const { items, counts } = await getPendingToFinish();
        this.items = items;
        this.counts = counts;
      } catch (error) {
        console.log("Error on get pendingToFinish =>", error);
      }
    },
    toggleSortOrder(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.sortData();
    },
    sortData() {
      this.items.sort((a, b) => {
        const valueA = a[this.sortField];
        const valueB = b[this.sortField];

        if (typeof valueA === "number" && typeof valueB === "number") {
          return this.sortOrder === "asc" ? valueA - valueB : valueB - valueA;
        } else if (typeof valueA === "string" && typeof valueB === "string") {
          return this.sortOrder === "asc"
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }

        return 0;
      });
    },
  },
  computed: {
    getTodayFormat,
    formatDate,
    formatDateUTC,
    filteredItems: function () {
      return filterItems(this.search, this.items);
    },
  },
};
</script>

<style lang="scss" src="./PendingToFinish.scss" scoped></style>
